import {
  SHIFTS_GET_LIST,
  SHIFTS_GET_LIST_SUCCESS,
  SHIFTS_GET_LIST_ERROR,
  SHIFTS_GET_LIST_WITH_FILTER,
  SHIFTS_GET_LIST_WITH_ORDER,
  SHIFTS_GET_LIST_SEARCH,
  SHIFTS_SELECTED_ITEMS_CHANGE,
  SHIFTS_EDIT_ITEM,
  SHIFTS_EDIT_ITEM_SUCCESS,
  SHIFTS_EDIT_ITEM_ERROR,
  SHIFTS_DELETE_ITEM,
  SHIFTS_DELETE_ITEM_SUCCESS,
  SHIFTS_DELETE_ITEM_ERROR,
} from '../actions';

export const getShiftsList = () => ({
  type: SHIFTS_GET_LIST,
});

export const getShiftsListSuccess = items => ({
  type: SHIFTS_GET_LIST_SUCCESS,
  payload: items,
});

export const getShiftsListError = error => ({
  type: SHIFTS_GET_LIST_ERROR,
  payload: error,
});

export const getShiftsListWithFilter = (column, value) => ({
  type: SHIFTS_GET_LIST_WITH_FILTER,
  payload: { column, value },
});

export const getShiftsListWithOrder = column => ({
  type: SHIFTS_GET_LIST_WITH_ORDER,
  payload: column,
});

export const getShiftsListSearch = keyword => ({
  type: SHIFTS_GET_LIST_SEARCH,
  payload: keyword,
});

export const editShiftsItem = item => ({
  type: SHIFTS_EDIT_ITEM,
  payload: item,
});

export const editShiftsItemSuccess = items => ({
  type: SHIFTS_EDIT_ITEM_SUCCESS,
  payload: items,
});

export const editShiftsItemError = error => ({
  type: SHIFTS_EDIT_ITEM_ERROR,
  payload: error,
});

export const selectedShiftsItemsChange = selectedItems => ({
  type: SHIFTS_SELECTED_ITEMS_CHANGE,
  payload: selectedItems,
});

export const deleteShiftsItem = item => ({
  type: SHIFTS_DELETE_ITEM,
  payload: item,
});

export const deleteShiftsItemSuccess = items => ({
  type: SHIFTS_DELETE_ITEM_SUCCESS,
  payload: items,
});

export const deleteShiftsItemError = error => ({
  type: SHIFTS_DELETE_ITEM_ERROR,
  payload: error,
});
